import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock } from "vue"

import {onMounted, provide} from "vue"
import {useI18n} from "vue-i18n"
import {useKeepAlive} from "@/services/keep-alive-hook"
import {LoginSuccessActionKey} from "@/login-success-action"
import Login from "@/views/Login.vue"


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const i18n = useI18n()

const keepAlive = useKeepAlive()

const loginSuccessAction = (): void => {
    window.location.href = "/"
}

provide(LoginSuccessActionKey, loginSuccessAction)

onMounted(() => {
    document.title = i18n.t("appName")
    keepAlive.set()
})


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Login))
}
}

})